import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedGaugeMeterHighV1 = reactify('zui-icon-med-gauge-meter-high-v-1');
